import React, { PureComponent } from 'react';
import { Text } from 'common-components/typography';
import { PaymentStatus } from 'utilities/enum-utils';
import { Badge } from '@good/ui/core';

interface IActivityRecordTagProps {
  size?: 'small' | 'default' | 'large';
  textSize?: string;
  className?: string;
  textClassName?: string;
  rounded?: boolean;
}

class ActivityRecordTag extends PureComponent<IActivityRecordTagProps, any> {
  override render() {
    const { className, size = 'default' } = this.props;

    const size_ =
      {
        small: 'md',
        default: 'lg',
        large: 'xl',
      }[size] ?? 'lg';

    return (
      <Badge variant='light' color='blue' className={className} size={size_}>
        Activity Record
      </Badge>
    );
  }
}

interface IActivityRecordStatusTagProps {
  size?: 'small' | 'default' | 'large';
  textSize?: string;
  className?: any;
  textClassName?: any;
  rounded?: boolean;
  paymentStatus: string;
}

class ActivityRecordStatusTag extends PureComponent<IActivityRecordStatusTagProps, any> {
  override render() {
    const {
      className,
      textClassName,
      textSize = 'large',
      size = 'default',
      rounded = true,
      paymentStatus,
    } = this.props;

    let text: string;
    let color: string;
    let variant: string;

    switch (paymentStatus) {
      case PaymentStatus.REQUIRES_APPROVAL:
        text = 'Pending';
        color = 'orange';
        variant = 'light';
        break;
      case PaymentStatus.SEND_TO_FINANCE:
      case PaymentStatus.PROCESSED:
      case PaymentStatus.REJECTED:
      case PaymentStatus.PAID:
      case PaymentStatus.BILLING_FAILED:
        text = 'Approved';
        color = 'blue';
        variant = 'light';
        break;
      case PaymentStatus.WAIVED:
        text = 'Waived';
        color = 'red';
        variant = 'light';
        break;
      default:
        text = '';
        color = 'gray';
        variant = 'light';
    }

    const size_ =
      {
        small: 'md',
        default: 'lg',
        large: 'xl',
      }[size] ?? 'lg';

    return (
      <Badge variant={variant} color={color} className={className} size={size_}>
        {text}
      </Badge>
    );
  }
}

export { ActivityRecordTag, ActivityRecordStatusTag };
